<script setup lang="ts">
const props = defineProps<{
  companyPub: any;
  categories: any;
}>();

const { id } = useRoute().params;

const { state } = useAppStore();

const { data: pastScores } = await useFetch<any>(`/api/data/company/${id}/history?year=2`);

const companyIsRetailer = computed(() => {
  return props.companyPub.type_id == 3;
});
</script>

<template>
  <section v-if="pastScores && pastScores.length > 0 && companyPub" class="py-32 bg-chsc-raw">
    <UContainer>
      <header class="mb-12 text-center">
        <h2 class="text-chsc-indigo-500 fs-4xl font-eb-garamond font-medium">
          {{ useText(state.strings, "sc_past_scores") }}
        </h2>
      </header>
      <div class="flex flex-col overflow-x-auto [&>div]:min-w-[1024px]">
        <div class="w-full flex">
          <div class="w-[100px]" />
          <div
            v-for="category in state.categories.filter(
              (category: any) => category.id != 9 && category.id != 8,
            )"
            :key="category.id"
            class="flex-1 flex flex-col"
          >
            <p class="fs-xs uppercase text-center">
              {{ useCategoryName(state.categories, category.id) }}
            </p>
          </div>
          <div class="flex-1 flex flex-col">
            <p class="fs-xs uppercase text-center">
              {{ useText(state.strings, "sc_cat_ov") }}
            </p>
          </div>
        </div>
        <div class="w-full flex items-center">
          <p class="w-[100px] fs-xs font-bold uppercase">
            {{ useText(state.strings, "sc_edition_7") }}
          </p>
          <div
            v-for="category in state.categories
              .filter((category: any) => category.id != 9 && category.id != 8)
              .sort((a: any, b: any) => a.id - b.id)"
            :key="category.id"
            class="flex-1 flex flex-col items-center justify-center"
          >
            <img
              v-if="companyPub.scores.find((score: any) => score.category_id == category.id)"
              :src="`/img/treshold-${useScoreTreshold(companyPub.scores.find((score: any) => score.category_id == category.id).over_100).treshold}.svg`"
              class="w-[48px] mx-auto"
            />
            <img v-else src="/img/treshold-5.svg" class="w-[48px] mx-auto" />
          </div>
          <div class="flex-1 flex flex-col items-center justify-center">
            <img
              v-if="
                companyPub.scores.length &&
                companyPub.scores.find((score: any) => !score.category_id)
              "
              :src="`/img/treshold-${useScoreTreshold(companyPub.scores.find((score: any) => !score.category_id).over_100).treshold}.svg`"
              class="w-[65px]"
            />
            <img v-else src="/img/treshold-5.svg" class="w-[65px]" />
          </div>
        </div>
        <div class="w-full flex items-center">
          <p class="w-[100px]" />
          <div
            v-for="category in state.categories
              .filter((category: any) => category.id != 9 && category.id != 8)
              .sort((a: any, b: any) => a.id - b.id)"
            :key="category.id"
            class="flex-1 flex flex-col items-center justify-center h-[50px] relative"
          >
            <div class="w-px h-full absolute bg-chsc-border left-1/2 top-0" />
            <div
              class="w-[27px] h-[27px] rounded-full bg-chsc-raw-light flex items-center justify-center border border-chsc-border z-1"
            >
              <UIcon
                v-if="
                  companyPub.scores.find((score: any) => score.category_id == category.id) &&
                  pastScores[3].scores.find((score: any) => score.category_id == category.id)
                "
                :name="
                  useTresholdComparision(
                    useScoreTreshold(
                      companyPub.scores.find((score: any) => score.category_id == category.id)
                        ?.over_100,
                    ).treshold,
                    useScoreColorTreshold(
                      pastScores[3].scores.find((score: any) => score.category_id == category.id)
                        .color,
                    ),
                  )
                "
              />
            </div>
          </div>
          <div class="flex-1 flex flex-col items-center justify-center h-[50px] relative">
            <div class="w-px h-full absolute bg-chsc-border left-1/2 top-0" />
            <div
              class="w-[27px] h-[27px] rounded-full bg-chsc-raw-light flex items-center justify-center border border-chsc-border z-1"
            >
              <UIcon
                v-if="
                  companyPub.scores.find((score: any) => !score.category_id) &&
                  pastScores[3].scores.find((score: any) => !score.category_id)
                "
                :name="
                  useTresholdComparision(
                    useScoreTreshold(
                      companyPub.scores.find((score: any) => !score.category_id)?.over_100,
                    ).treshold,
                    useScoreColorTreshold(
                      pastScores[3].scores.find((score: any) => !score.category_id).color,
                    ),
                  )
                "
              />
            </div>
          </div>
        </div>
        <div class="w-full flex items-center">
          <p class="w-[100px] fs-xs font-bold uppercase">
            {{ useText(state.strings, "sc_edition_6") }}
          </p>
          <div
            v-for="category in state.categories
              .filter((category: any) => category.id != 9 && category.id != 8)
              .sort((a: any, b: any) => a.id - b.id)"
            :key="category.id"
            class="flex-1 flex flex-col items-center justify-center"
          >
            <img
              v-if="pastScores[3].scores.find((score: any) => score.category_id == category.id)"
              :src="`/img/treshold-${useScoreColorTreshold(pastScores[3].scores.find((score: any) => score.category_id == category.id).color)}.svg`"
              class="w-[48px] mx-auto"
            />
          </div>
          <div class="flex-1 flex flex-col items-center justify-center">
            <img
              v-if="pastScores[3].scores.find((score: any) => !score.category_id)"
              :src="`/img/treshold-${useScoreColorTreshold(pastScores[3].scores.find((score: any) => !score.category_id).color)}.svg`"
              class="w-[65px]"
            />
          </div>
        </div>
        <div class="w-full flex items-center">
          <p class="w-[100px]" />
          <div
            v-for="category in state.categories
              .filter((category: any) => category.id != 9 && category.id != 8)
              .sort((a: any, b: any) => a.id - b.id)"
            :key="category.id"
            class="flex-1 flex flex-col items-center justify-center h-[50px] relative"
          >
            <div class="w-px h-full absolute bg-chsc-border left-1/2 top-0" />
            <div
              class="w-[27px] h-[27px] rounded-full bg-chsc-raw-light flex items-center justify-center border border-chsc-border z-1"
            >
              <UIcon
                v-if="
                  companyPub.scores.find((score: any) => score.category_id == category.id) &&
                  pastScores[3].scores.find((score: any) => score.category_id == category.id)
                "
                :name="
                  useTresholdComparision(
                    useScoreColorTreshold(
                      pastScores[3].scores.find((score: any) => score.category_id == category.id)
                        .color,
                    ),
                    useScoreColorTreshold(
                      pastScores[2].scores.find((score: any) => score.category_id == category.id)
                        .color,
                    ),
                  )
                "
              />
            </div>
          </div>
          <div class="flex-1 flex flex-col items-center justify-center h-[50px] relative">
            <div class="w-px h-full absolute bg-chsc-border left-1/2 top-0" />
            <div
              class="w-[27px] h-[27px] rounded-full bg-chsc-raw-light flex items-center justify-center border border-chsc-border z-1"
            >
              <UIcon
                v-if="
                  companyPub.scores.find((score: any) => !score.category_id) &&
                  pastScores[3].scores.find((score: any) => !score.category_id)
                "
                :name="
                  useTresholdComparision(
                    useScoreColorTreshold(
                      pastScores[3].scores.find((score: any) => !score.category_id).color,
                    ),
                    useScoreColorTreshold(
                      pastScores[2].scores.find((score: any) => !score.category_id).color,
                    ),
                  )
                "
              />
            </div>
          </div>
        </div>
        <div class="w-full flex items-center">
          <p class="w-[100px] fs-xs font-bold uppercase">
            {{ useText(state.strings, "sc_edition_5") }}
          </p>
          <div
            v-for="category in state.categories
              .filter((category: any) => category.id != 9 && category.id != 8)
              .sort((a: any, b: any) => a.id - b.id)"
            :key="category.id"
            class="flex-1 flex flex-col items-center justify-center"
          >
            <img
              v-if="pastScores[2].scores.find((score: any) => score.category_id == category.id)"
              :src="`/img/treshold-${useScoreColorTreshold(pastScores[2].scores.find((score: any) => score.category_id == category.id).color)}.svg`"
              class="w-[48px] mx-auto"
            />
          </div>
          <div class="flex-1 flex flex-col items-center justify-center">
            <img
              v-if="pastScores[2].scores.find((score: any) => !score.category_id)"
              :src="`/img/treshold-${useScoreColorTreshold(pastScores[2].scores.find((score: any) => !score.category_id).color)}.svg`"
              class="w-[65px]"
            />
          </div>
        </div>
        <div class="w-full flex items-center">
          <p class="w-[100px]" />
          <div
            v-for="category in categories
              .filter((category: any) => category.id != 9 && category.id != 8)
              .sort((a: any, b: any) => a.id - b.id)"
            :key="category.id"
            class="flex-1 flex flex-col items-center justify-center h-[50px] relative"
          >
            <div class="w-px h-full absolute bg-chsc-border left-1/2 top-0" />
            <div
              class="w-[27px] h-[27px] rounded-full bg-chsc-raw-light flex items-center justify-center border border-chsc-border z-1"
            >
              <UIcon
                v-if="
                  companyPub.scores.find((score: any) => score.category_id == category.id) &&
                  pastScores[2].scores.find((score: any) => score.category_id == category.id)
                "
                :name="
                  useTresholdComparision(
                    useScoreColorTreshold(
                      pastScores[2].scores.find((score: any) => score.category_id == category.id)
                        .color,
                    ),
                    useScoreColorTreshold(
                      pastScores[1].scores.find((score: any) => score.category_id == category.id)
                        .color,
                    ),
                  )
                "
              />
            </div>
          </div>
          <div class="flex-1 flex flex-col items-center justify-center h-[50px] relative">
            <div class="w-px h-full absolute bg-chsc-border left-1/2 top-0" />
            <div
              class="w-[27px] h-[27px] rounded-full bg-chsc-raw-light flex items-center justify-center border border-chsc-border z-1"
            >
              <UIcon
                v-if="
                  companyPub.scores.find((score: any) => !score.category_id) &&
                  pastScores[2].scores.find((score: any) => !score.category_id)
                "
                :name="
                  useTresholdComparision(
                    useScoreColorTreshold(
                      pastScores[2].scores.find((score: any) => !score.category_id).color,
                    ),
                    useScoreColorTreshold(
                      pastScores[1].scores.find((score: any) => !score.category_id).color,
                    ),
                  )
                "
              />
            </div>
          </div>
        </div>
        <div class="w-full flex items-center">
          <p class="w-[100px] fs-xs font-bold uppercase">
            {{ useText(state.strings, "sc_edition_4") }}
          </p>
          <div
            v-for="category in state.categories
              .filter((category: any) => category.id != 9 && category.id != 8)
              .sort((a: any, b: any) => a.id - b.id)"
            :key="category.id"
            class="flex-1 flex flex-col items-center justify-center"
          >
            <img
              v-if="pastScores[1].scores.find((score: any) => score.category_id == category.id)"
              :src="`/img/treshold-${useScoreColorTreshold(pastScores[1].scores.find((score: any) => score.category_id == category.id).color)}.svg`"
              class="w-[48px] mx-auto"
            />
          </div>
          <div class="flex-1 flex flex-col items-center justify-center">
            <img
              v-if="pastScores[1].scores.find((score: any) => !score.category_id)"
              :src="`/img/treshold-${useScoreColorTreshold(pastScores[1].scores.find((score: any) => !score.category_id).color)}.svg`"
              class="w-[65px]"
            />
          </div>
        </div>
        <div v-if="!companyIsRetailer" class="w-full flex items-center">
          <p class="w-[100px]" />
          <div
            v-for="category in state.categories
              .filter((category: any) => category.id != 9 && category.id != 8)
              .sort((a: any, b: any) => a.id - b.id)"
            :key="category.id"
            class="flex-1 flex flex-col items-center justify-center h-[50px] relative"
          >
            <div class="w-px h-full absolute bg-chsc-border left-1/2 top-0" />
            <div
              class="w-[27px] h-[27px] rounded-full bg-chsc-raw-light flex items-center justify-center border border-chsc-border z-1"
            >
              <UIcon
                v-if="
                  companyPub.scores.find((score: any) => score.category_id == category.id) &&
                  pastScores[1].scores.find((score: any) => score.category_id == category.id)
                "
                :name="
                  useTresholdComparision(
                    useScoreColorTreshold(
                      pastScores[1].scores.find((score: any) => score.category_id == category.id)
                        .color,
                    ),
                    useScoreColorTreshold(
                      pastScores[0].scores.find((score: any) => score.category_id == category.id)
                        .color,
                    ),
                  )
                "
              />
            </div>
          </div>
          <div class="flex-1 flex flex-col items-center justify-center h-[50px] relative">
            <div class="w-px h-full absolute bg-chsc-border left-1/2 top-0" />
            <div
              class="w-[27px] h-[27px] rounded-full bg-chsc-raw-light flex items-center justify-center border border-chsc-border z-1"
            >
              <UIcon
                v-if="
                  companyPub.scores.find((score: any) => !score.category_id) &&
                  pastScores[1].scores.find((score: any) => !score.category_id)
                "
                :name="
                  useTresholdComparision(
                    useScoreColorTreshold(
                      pastScores[1].scores.find((score: any) => !score.category_id).color,
                    ),
                    useScoreColorTreshold(
                      pastScores[0].scores.find((score: any) => !score.category_id).color,
                    ),
                  )
                "
              />
            </div>
          </div>
        </div>
        <div v-if="!companyIsRetailer" class="w-full flex items-center">
          <p class="w-[100px] fs-xs font-bold uppercase">
            {{ useText(state.strings, "sc_edition_3") }}
          </p>
          <div
            v-for="category in state.categories
              .filter((category: any) => category.id != 9 && category.id != 8)
              .sort((a: any, b: any) => a.id - b.id)"
            :key="category.id"
            class="flex-1 flex flex-col items-center justify-center"
          >
            <img
              v-if="pastScores[0].scores.find((score: any) => score.category_id == category.id)"
              :src="`/img/treshold-${useScoreColorTreshold(pastScores[0].scores.find((score: any) => score.category_id == category.id).color)}.svg`"
              class="w-[48px] mx-auto"
            />
          </div>
          <div class="flex-1 flex flex-col items-center justify-center">
            <img
              v-if="pastScores[0].scores.find((score: any) => !score.category_id)"
              :src="`/img/treshold-${useScoreColorTreshold(pastScores[0].scores.find((score: any) => !score.category_id).color)}.svg`"
              class="w-[65px]"
            />
          </div>
        </div>
      </div>
    </UContainer>
  </section>
</template>
